import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/perfil/';

class PerfilService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAllByFiltro(idCliente, filtro) {
        return axios.get(API_URL + 'all?idCliente='+idCliente+'&filtro='+filtro, {headers: this.headers});
    }
    
    save(perfil) {
        return axios.post(API_URL, JSON.stringify(perfil),
        {headers: this.headers});
    }

    get(perfilId) {
        return axios.get(API_URL+perfilId, {headers: this.headers});
    }

    remove(perfilId) {
        return axios.delete(API_URL+perfilId, {headers: this.headers});
    }

}

export default new PerfilService();